/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Back_To_ListInputs */

const en_ticket_back_to_list = /** @type {(inputs: Ticket_Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to tickets`)
};

const ja_ticket_back_to_list = /** @type {(inputs: Ticket_Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チケット一覧に戻る`)
};

const fr_ticket_back_to_list = /** @type {(inputs: Ticket_Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour aux tickets`)
};

const de_ticket_back_to_list = /** @type {(inputs: Ticket_Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Tickets`)
};

/**
* | output |
* | --- |
* | "Back to tickets" |
*
* @param {Ticket_Back_To_ListInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_back_to_list = /** @type {((inputs?: Ticket_Back_To_ListInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Back_To_ListInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_back_to_list(inputs)
	if (locale === "ja") return ja_ticket_back_to_list(inputs)
	if (locale === "fr") return fr_ticket_back_to_list(inputs)
	return de_ticket_back_to_list(inputs)
});